import type { SxProps, Theme } from "@mui/material";
import { Paper, Stack, Typography } from "@mui/material";
import type { PropsWithChildren } from "react";

interface Props {
  title: string;
  value: string;
  sx?: SxProps<Theme>;
}

const StatTile = ({ title, value, sx, children }: PropsWithChildren<Props>) => {
  return (
    <Paper variant="outlined" sx={{ p: 2, ...sx }}>
      <Stack spacing={1}>
        <Typography color="textSecondary">{title}</Typography>
        <Typography variant="h2">{value}</Typography>
        {children}
      </Stack>
    </Paper>
  );
};

export default StatTile;
